import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  token: "",
  isLogin: false,
  user: null,
  isPasswordUpdated: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action) => {
      state.token = action.payload.token;
      state.user = action.payload;
      state.isLogin = true;
    },
    WALogin: (state, action) => {
      state.isPasswordUpdated = action.payload.isWANewLogin;
    },
    logout: (state) => {
      state.token = "";
      state.isLogin = false;
      state.user = null;
      state.isPasswordUpdated = false;
    },
  },
});

export const { login, logout, WALogin } = authSlice.actions;
export default authSlice.reducer;
